import React, { useState } from 'react'
import { testVideoInputDevice, VideoInputTest } from '@twilio/rtc-diagnostics'

function useVideoTest() {
  const [videoInputReport, setVideoReport] = useState(null)

  const testVideoInput = async () => {
    return new Promise((resolve, reject) => {
      const videoInputDeviceTest = testVideoInputDevice()
      videoInputDeviceTest.on(VideoInputTest.Events.Error, error => {
        console.error(error)
      })
      setTimeout(() => {
        videoInputDeviceTest.stop()
      }, 10000)
      videoInputDeviceTest.on(VideoInputTest.Events.End, report => {
        setVideoReport(report)
        if (report?.errors.length !== 0) {
          reject(report)
        } else {
          resolve(report)
        }
      })
    })
  }
  return {
    videoInputReport,
    setVideoReport,
    testVideoInput,
  }
}
export default useVideoTest
